var map = {
	"./address.js": 65855,
	"./business.js": 33589,
	"./category.js": 64711,
	"./currency.js": 94280,
	"./customer.js": 28319,
	"./customerJournal.js": 73580,
	"./employee.js": 37503,
	"./feedback.js": 91284,
	"./notice.js": 34643,
	"./payment.js": 80721,
	"./routes.js": 55501,
	"./stock.js": 88241,
	"./supply.js": 66856,
	"./sys.js": 13178,
	"./tabsBar.js": 28426,
	"./user.js": 12296,
	"./wholesale.js": 70023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78043;